import { ProgressBar } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RulesBulkUpload from 'Components/RulesBulkUpload';
import appStyles from 'Routes/Routes.css';
import { useUploaderContext } from '../Uploader/context';
import styles from './ChunkingProcess.css';
import Cancelation from './Cancelation';

const ChunkingProcess = () => {
    const { t } = useTranslation();
    const { currentChunkNumber, fileDetails, listName } = useUploaderContext();

    return (
        <div data-testid='list-page-bulk-upload-chunking-container'>
            <RulesBulkUpload.Title
                title={t('singleListBulkUpload.title', { listName })}
                dataTestId='list-page-bulk-upload-title'
            />
            <div className={styles.chunkingInstructions} data-testid='bulk-upload-chunking-instructions'>
                <p>
                    <span className={appStyles.bold}>{t('singleListBulkUpload.remain')}</span>
                    {t('singleListBulkUpload.leavingWarning')}
                </p>
            </div>
            <div className={styles.bulkProgress}>
                <ProgressBar
                    dataTestId='list-page-bulk-upload-chunking-progress-bar'
                    className={styles.progressBar}
                    hasLabel={false}
                    size='lg'
                    progress={currentChunkNumber / fileDetails.totalChunks}
                />
                <span data-testid='list-page-bulk-upload-current-chunk'>
                    {t('singleListBulkUpload.chunksBeingUploaded', {
                        chunkNumber: currentChunkNumber,
                        totalChunks: fileDetails.totalChunks
                    })}
                </span>
            </div>
            <Cancelation />
        </div>
    );
};

export default ChunkingProcess;
